module.exports = __webpack_public_path__ + "img/NW12.377bf931.jpg";